import CheckboxCheckedSvg from "@icons/checkbox.checked.svg?react";
import { RegisterOptions, useFormContext } from "react-hook-form";

const List = ({ children }: React.PropsWithChildren) => {
  return <ul className="flex w-full flex-col">{children}</ul>;
};

const Checkbox = ({
  children,
  name,
  value,
  options,
}: React.PropsWithChildren<{
  name: string;
  options: RegisterOptions;
  value: string;
}>) => {
  const form = useFormContext();
  return (
    <span className="relative flex items-center gap-x-2">
      <input
        {...form.register(name, options)}
        className="peer absolute top-0 left-0 h-0 w-0 opacity-0"
        id={value}
        type="radio"
        value={value}
      />
      <span className="bg-can-silver-gray h-5 w-5 shrink-0 rounded-full peer-checked:invisible!" />
      <CheckboxCheckedSvg className="invisible -ml-7 peer-checked:visible!" />
      {children}
    </span>
  );
};

const Item = ({ children }: React.PropsWithChildren) => {
  return (
    <li className="border-can-silver-cloud border-t-can-silver-cloud first:border-l-can-silver-cloud first:border-r-can-silver-cloud last:border-l-can-silver-cloud last:border-r-can-silver-cloud has-[input:checked]:bg-can-silver-gray border border-t border-b-0 first:rounded-tl-2xl first:rounded-tr-2xl first:border-r first:border-l last:rounded-br-2xl last:rounded-bl-2xl last:border-r last:border-b last:border-l">
      {children}
    </li>
  );
};

const Label = ({ children }: React.PropsWithChildren) => {
  return (
    <label className="flex flex-wrap justify-between p-3 text-xs sm:text-base">
      {children}
    </label>
  );
};

export { Checkbox, Item, Label, List };
